import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Login from './pages/login';
import PrivacyPolicy from './pages/privacy-policy';
import TermsOfService from './pages/terms-of-service';
import AdministrationPanel from './pages/administration-panel';
import DrillDownAnalysis from './pages/drill-down-analysis';
import ExecutiveView from './pages/executive-view';
import AIChatOverlay from './components/AIChatOverlay';
import useGoogleAnalytics from './hooks/useGoogleAnalytics';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppRoutes = () => {
  // Initialize Google Analytics inside BrowserRouter context
  useGoogleAnalytics();

  return (
    <>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route 
          path="/administration-panel" 
          element={
            <ProtectedRoute>
              <AdministrationPanel />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/drill-down-analysis" 
          element={
            <ProtectedRoute>
              <DrillDownAnalysis />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/executive-view" 
          element={
            <ProtectedRoute>
              <ExecutiveView />
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      <AIChatOverlay />
    </>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
